
// Rates & History - City (Top Routes)

import React, {useEffect, useState} from "react";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import LaneService from "../services/LaneService";
import Select from "react-select";
import 'react-tooltip/dist/react-tooltip.css'
import AsyncSelect from "react-select/async";
import UserService from "../services/UserService";
import 'react-data-grid/lib/styles.css';
import {PageLoader} from "./PageLoader";
import {customStyles, equipmentTypeStyles, radiusStyles, pickRadiusStyles, dropRadiusStyles, pickCityStyles, dropCityStyles} from "../pages/Constants";
import DataTable from "react-data-table-component";
import {confirmAlert} from "react-confirm-alert";
import '../styles/components/city-search-advanced.css';

export const CitySearchAdvanced = () => {

    const [state, setState] = useState({
        messaged: '',
        apiMessage: undefined,
        error: null,
        error: null,
        subscription: false,
        subscriptionType: 'Default'
    });

    const equipmentOptions = [
        {value: 'Dry Van', label: 'Dry Van'},
        {value: 'Flatbed', label: 'Flatbed'},
        {value: 'Reefer', label: 'Reefer'},
        {value: 'Reefer', label: '\r'},
        
        {value: 'All', label: 'All'},
        {value: 'Auto Carrier', label: 'Auto Carrier'},
        {value: 'B-Train', label: 'B-Train'},
        {value: 'Box Truck', label: 'Box Truck'},
        {value: 'Cattle Trailer', label: 'Cattle Trailer'},
        {value: 'Conestoga', label: 'Conestoga'},
        {value: 'Container', label: 'Container'},
        {value: 'Conveyor', label: 'Conveyor'},
        {value: 'Double Drop', label: 'Double Drop'},
        {value: 'Drop Deck', label: 'Drop Deck'},
        {value: 'Dry Chassis', label: 'Dry Chassis'},
        {value: 'Dump Trailer', label: 'Dump Trailer'},
        {value: 'Hopper Bottom', label: 'Hopper Bottom'},
        {value: 'Lowboy', label: 'Lowboy'},
        {value: 'Maxi', label: 'Maxi'},
        {value: 'Moving Van', label: 'Moving Van'},
        {value: 'Pneumatic', label: 'Pneumatic'},
        {value: 'Power Only', label: 'Power Only'},
        {value: 'Reefer Double', label: 'Reefer Double'},
        {value: 'Removable Gooseneck', label: 'Removable Gooseneck'},
        {value: 'Sprinter', label: 'Sprinter'},
        {value: 'Step Deck', label: 'Step Deck'},
        {value: 'Straight Box Reefer', label: 'Straight Box Reefer'},
        {value: 'Straight Box', label: 'Straight Box'},
        {value: 'Stretch Trailer', label: 'Stretch Trailer'},
        {value: 'Tanker', label: 'Tanker'},
        {value: 'Truck and Trailer', label: 'Truck & Trailer'},
        {value: 'Walking Floor', label: 'Walking Floor'},
    ]

    const dayRangeOptions = [
        {value: 3, label: '3 days'},
        {value: 7, label: '7 days'},
        {value: 15, label: '15 days'},
        {value: 30, label: '30 days'},
        {value: 45, label: '45 days'},
        {value: 60, label: '60 days'},
        {value: 90, label: '90 days'},
        {value: 120, label: '120 days'},
    ];

    const handleDayRangeValueChange = value => {
        setDayRangeValue(value);
    };

    const [dayRangeValue, setDayRangeValue] = useState({value: 30, label: '30 days'});

    const [apiFinished, setApiFinished] = React.useState(true);
    const {user, getAccessTokenSilently} = useAuth0();

    const callApi = async () => {
        const token = await getAccessTokenSilently();
        UserService.userSubscriptionStatusPair(token, user).then(
            response => {
                setState({
                    subscription: response.data.status,
                    subscriptionType: response.data.subscriptionType
                })
            },
            error => {
            }
        );
    };

    useEffect(() => {
        callApi().then(r => console.log('Call() finished'));
    }, []);

    const financialNoDecimals = (x) => Number.parseFloat(x).toFixed(0);
    const financialTwoPoints = (x) => Number.parseFloat(x).toFixed(2);

    // Correct columns that match your actual API response data structure
    const columns = [
        {
            name: 'Equipment',
            selector: row => row.equipment,
            sortable: true,
            cell: row => <div>{row.equipment}</div>,
        },
        {
            name: 'Pick City',
            selector: row => row.pickCity + ', ' + row.pickState,
            sortable: true,
            cell: row => <div>{row.pickCity + ', ' + row.pickState}</div>,
        },
        {
            name: 'Drop City',
            selector: row => row.dropCity + ', ' + row.dropState,
            sortable: true,
            cell: row => <div>{row.dropCity + ', ' + row.dropState}</div>,
        },
        {
            name: 'Miles',
            selector: row => row.miles,
            sortable: true,
            cell: row => <div>{Math.round(row.miles)}</div>,
        },
        {
            name: '120 Days',
            selector: row => row.metrics120Days?.averageLineHaulRate || 0,
            sortable: true,
            cell: row => (
                <div className="rate-data rate-120">
                    {row.metrics120Days?.count > 0 ? (
                        <>
                            <div className="rate-line-haul">${Math.round(row.metrics120Days.averageLineHaulRate)}</div>
                            <div className="rate-per-mile">${row.metrics120Days.averagePricePerMile?.toFixed(2)}/mi</div>
                            <div className="rate-count">({row.metrics120Days.count} loads)</div>
                        </>
                    ) : (
                        <div className="no-data">No data</div>
                    )}
                </div>
            ),
        },
        {
            name: '60 Days',
            selector: row => row.metrics60Days?.averageLineHaulRate || 0,
            sortable: true,
            cell: row => (
                <div className="rate-data rate-60">
                    {row.metrics60Days?.count > 0 ? (
                        <>
                            <div className="rate-line-haul">${Math.round(row.metrics60Days.averageLineHaulRate)}</div>
                            <div className="rate-per-mile">${row.metrics60Days.averagePricePerMile?.toFixed(2)}/mi</div>
                            <div className="rate-count">({row.metrics60Days.count} loads)</div>
                        </>
                    ) : (
                        <div className="no-data">No data</div>
                    )}
                </div>
            ),
        },
        {
            name: '30 Days',
            selector: row => row.metrics30Days?.averageLineHaulRate || 0,
            sortable: true,
            cell: row => (
                <div className="rate-data rate-30">
                    {row.metrics30Days?.count > 0 ? (
                        <>
                            <div className="rate-line-haul">${Math.round(row.metrics30Days.averageLineHaulRate)}</div>
                            <div className="rate-per-mile">${row.metrics30Days.averagePricePerMile?.toFixed(2)}/mi</div>
                            <div className="rate-count">({row.metrics30Days.count} loads)</div>
                        </>
                    ) : (
                        <div className="no-data">No data</div>
                    )}
                </div>
            ),
        },
        {
            id: '7days',
            name: '7 Days',
            selector: row => row.metrics7Days?.averageLineHaulRate || 0,
            sortable: true,
            cell: row => (
                <div className="rate-data rate-7">
                    {row.metrics7Days?.count > 0 ? (
                        <>
                            <div className="rate-line-haul">${Math.round(row.metrics7Days.averageLineHaulRate)}</div>
                            <div className="rate-per-mile">${row.metrics7Days.averagePricePerMile?.toFixed(2)}/mi</div>
                            <div className="rate-count">({row.metrics7Days.count} loads)</div>
                        </>
                    ) : (
                        <div className="no-data">No data</div>
                    )}
                </div>
            ),
        },
        {
            name: '3 Days',
            selector: row => row.metrics3Days?.averageLineHaulRate || 0,
            sortable: true,
            cell: row => (
                <div className="rate-data rate-3">
                    {row.metrics3Days?.count > 0 ? (
                        <>
                            <div className="rate-line-haul">${Math.round(row.metrics3Days.averageLineHaulRate)}</div>
                            <div className="rate-per-mile">${row.metrics3Days.averagePricePerMile?.toFixed(2)}/mi</div>
                            <div className="rate-count">({row.metrics3Days.count} loads)</div>
                        </>
                    ) : (
                        <div className="no-data">No data</div>
                    )}
                </div>
            ),
        }
    ];

    // Spicy custom table styles with animations and colors
    const spicyTableStyles = {    };

    const handleEquipmentChange = (event) => {
        setEquipmentValue(event);
    };
    
    const [submitted, setSubmitted] = useState(false);
    const [laneStatistics, setLaneStatistics] = useState('default');
    const [inputPickCityValue, setPickCityValue] = useState('');
    const [inputDropCityValue, setDropCityValue] = useState('');
    const [selectedPickCityValue, setSelectedPickCityValue] = useState(null);
    const [selectedDropCityValue, setSelectedDropCityValue] = useState(null);
    const [selectedRateSearchHistoryValue, setSelectedRateSearchHistoryValue] = useState(null);
    const [searchHistoryValue, setSearchHistoryValue] = useState({value: 'Dry Van', label: 'Recent Search History'});
    const [equipmentValue, setEquipmentValue] = useState({value: 'All', label: 'All'});
    const [rateSearchHistoryValue, setRateSearchHistoryValue] = useState({
        pick_state: '', radius_miles: 'Dry Van',
        pick_city: 'Select user search history here'
    });
    const [radiusValue, setRadiusValue] = useState({value: -1, label: 'Select Miles'});
    const [pickCityRadiusValue, setPickCityRadiusValue] = useState({value: 200, label: '200 miles'});

    const pickCityRadiusOptions = [
        {value: 50, label: '50 miles'},
        {value: 100, label: '100 miles'},
        {value: 150, label: '150 miles'},
        {value: 200, label: '200 miles'},
        {value: 250, label: '250 miles'}
    ];

    const dropCityRadiusOptions = [
        {value: 50, label: '50 miles'},
        {value: 100, label: '100 miles'},
        {value: 150, label: '150 miles'},
        {value: 200, label: '200 miles'},
        {value: 250, label: '250 miles'}
    ]
    
    const handleRadiusChange = (event) => {
        setRadiusValue(event);
    };

    const handlePickCityRadiusChange = (event) => {
        setPickCityRadiusValue(event);
    };

    const handlePickCityInputChange = value => {
        setPickCityValue(value);
    };

    const handlePickCityChange = value => {
        setSelectedPickCityValue(value);
    }

    const handleDropCityInputChange = value => {
        setDropCityValue(value);
    };

    const handleDropCityChange = value => {
        setSelectedDropCityValue(value);
    }
    
    const [message, setMessage] = React.useState("");

    const handleFormSubmit = async value => {
        setApiFinished(false);
        const token = await getAccessTokenSilently();
        if (null == selectedPickCityValue) {
            setMessage('Pick City cannot be empty.');
            console.log('Returning');
            setApiFinished(true);
            confirmAlert({
                title: 'Start City cannot be empty.',
                message: message,
                buttons: [
                    {
                        label: 'OK',
                        onClick: () => {
                            console.log('New Item dash errors so allowing the user to start over.')
                        }
                    }
                ]
            });
            return;
        }
        try {
            const token = await getAccessTokenSilently();
            console.log('"*********************');
            console.log(selectedDropCityValue);
            console.log(selectedDropCityValue);
            console.log(radiusValue);

            console.log('"*********************');
            let selectedDropCityValueForAPI = {};
            if (null == selectedDropCityValue) {
                selectedDropCityValueForAPI.city = "EMPTY";
                selectedDropCityValueForAPI.stateName = "EMPTY";
            } else {
                selectedDropCityValueForAPI.city = selectedDropCityValue.city;
                selectedDropCityValueForAPI.stateName = selectedDropCityValue.stateName;
            }

            LaneService.getCityOptionsThree(user.sub, token, selectedPickCityValue.city, selectedPickCityValue.stateName, pickCityRadiusValue.value, equipmentValue.value,
                selectedDropCityValueForAPI.city, selectedDropCityValueForAPI.stateName, radiusValue.value,dayRangeValue.value).then(
                response => {
                    console.log('API Response:', response);
                    console.log('Response Data:', response.cityPairs);
                    if (response.cityPairs && response.cityPairs.length > 0) {
                        console.log('First Row Data:', response.cityPairs[0]);
                        console.log('Data Keys:', Object.keys(response.cityPairs[0]));
                    }
                    if (null != response.cityPairs) {
                        // Sort by 7 days average line haul rate (highest first)
                        response.cityPairs.sort((a, b) => {
                            const rateA = a.metrics7Days?.averageLineHaulRate || 0;
                            const rateB = b.metrics7Days?.averageLineHaulRate || 0;
                            return rateB - rateA;
                        });
                    }
                    console.log('Sorted Data:', response.cityPairs);
                    setState({
                        ...state,
                        apiMessage: response
                    });
                    setApiFinished(true);
                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
        setSubmitted(true);
    }

    const loadOptions = async (inputValue) => {
        const token = await getAccessTokenSilently();
        
        // If no input or input is less than 3 characters, load default popular cities
        if (!inputValue || inputValue.length < 3) {
            return LaneService.getCityOptions('', token).then(
                response => {
                    return response;
                },
                error => {
                    console.log(error);
                    return [];
                }
            );
        }
        
        // Load cities based on search input
        return LaneService.getCityOptions(inputValue, token).then(
            response => {
                return response;
            },
            error => {
                console.log(error);
                return [];
            }
        );
    };

    return (
        <>

        	{/* --- FILTER ROW --- */}

			<div className="filter-row city-top-routes-filter-row">

            	<div className="filter-group">
               		<label>EQUIPMENT</label>
                    <Select
                    	label="What equipment"
                        options={equipmentOptions}
                        value={equipmentValue}
                        styles={equipmentTypeStyles}
                        className="filter-control equipment"
                        onChange={handleEquipmentChange}
                    />
				</div>
                <div className="filter-group">
                	<label className="pick-city">PICK CITY</label>
                    <AsyncSelect
                    	cacheOptions
                    	styles={pickCityStyles}
                    	className="filter-control pick"
                    	defaultOptions
                    	value={selectedPickCityValue}
                    	getOptionLabel={e => e.city + ', ' + e.stateName}
                    	getOptionValue={e => e.city}
                    	loadOptions={loadOptions}
                    	onInputChange={handlePickCityInputChange}
                    	onChange={handlePickCityChange}
                    />
                </div>
				<div className="filter-group">
	                <label className="pick">RADIUS</label>
	                <Select
	                    label="What radius"
	                    options={pickCityRadiusOptions}
	                    styles={pickRadiusStyles}
	                    className="filter-control pick"
	                    value={pickCityRadiusValue}
	                    onChange={handlePickCityRadiusChange}
	                />
	    		</div>
	    		<div className="filter-group">
	                <label className="drop-city">DROP CITY</label>
	                <AsyncSelect
	                    cacheOptions
	                    styles={dropCityStyles}
	                    className="filter-control drop"
	                    defaultOptions
	                    value={selectedDropCityValue}
	                    getOptionLabel={e => e.city + ', ' + e.stateName}
	                    getOptionValue={e => e.city}
	                    loadOptions={loadOptions}
	                    onInputChange={handleDropCityInputChange}
	                    onChange={handleDropCityChange}
	                />
	            </div>
	            <div className="filter-group">
	                <label className="drop">RADIUS</label>
	                <Select
	                    label="Drop Radius radius"
	                    options={dropCityRadiusOptions}
	                    styles={dropRadiusStyles}
	                    className="filter-control drop"
	                    value={radiusValue}
	                    onChange={handleRadiusChange}
	                />
	            </div>

               	<div className="query-group">
                	
                	<label>
                		{submitted && apiFinished && !state.apiMessage?.quotaFull
                			? <span>Your quota: {state.apiMessage?.quotaMessage}</span>
                			: <span>&nbsp;</span>
                    	}
                	</label>

                	<div>
                		<button className="query-button" onClick={handleFormSubmit} disabled={!apiFinished}>
                            {!apiFinished ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                            	<span>QUERY</span>
                            )}                            
                        </button>
                	</div>

                </div>

			</div>

			{/* --- RESULTS ROW --- */}

            <div className="city-search-advanced">

                <div className="filter-section">
                    <div className="filter-row"></div>
                </div>

                {!apiFinished && (
                    <div className="loading-container">
                        <PageLoader></PageLoader>
                    </div>
                )}

                {submitted && state.apiMessage && state.apiMessage.quotaFull && (
                    <div className="error-message">
                        {state.apiMessage.quotaMessage} Your monthly search quota has expired! Please try again later.
                    </div>
                )}

                {apiFinished && state.apiMessage && state.apiMessage.cityPairs && !state.apiMessage.quotaFull && (
                    <div className="results-section">
                        <div className="custom-data-table">
                            <DataTable
                                customStyles={spicyTableStyles}
                                striped={true}
                                columns={columns}
                                data={state.apiMessage.cityPairs}
                                defaultSortFieldId="7days"
                                defaultSortAsc={false}
                                direction="auto"
                                fixedHeaderScrollHeight="300px"
                                pagination
                                responsive
                                subHeaderAlign="right"
                                subHeaderWrap
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default withAuthenticationRequired(CitySearchAdvanced, {
    onRedirecting: () => <PageLoader/>,
});